module.exports = __webpack_public_path__ + "img/202510_03.3ae7660d.png";